var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Button } from '..';
import { useDay } from './hooks/useDay';
/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */
export function Day(props) {
    var buttonRef = React.useRef(null);
    var day = useDay(props.date, props.displayMonth, buttonRef);
    var buttonProps = day.buttonProps, nonInteractiveProps = day.nonInteractiveProps;
    if (!buttonProps && !nonInteractiveProps) {
        return React.createElement(React.Fragment, null);
    }
    if (nonInteractiveProps) {
        return React.createElement("div", __assign({}, nonInteractiveProps));
    }
    return React.createElement(Button, __assign({ ref: buttonRef }, buttonProps));
}
//# sourceMappingURL=Day.js.map